export default __webpack_public_path__ + "static/media/safe-money-logo.68c78f66.png";